module.exports = __webpack_public_path__ + "media/components/country-flag/static/so-3cf0dca4e25e0194a7cc966240181878.svg";